import ComposeLinkViewStore from './schema/ComposeLinkViewStore';
import { ObservableMap } from 'mobx';
import { createStore } from 'satcheljs';

const composeLinkViewStore: ComposeLinkViewStore = {
    composeLinks: new ObservableMap({}),
};

export const getStore = createStore<ComposeLinkViewStore>(
    'composeLinkViewStore',
    composeLinkViewStore
);
export default getStore;
